module.exports = __webpack_public_path__ + "img/1.cbd8f54b.jpg";